module.exports = __webpack_public_path__ + "img/changelangs.ca73b690.webp";